/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 5V3c0-1.1046.8954-2 2-2h11v4"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.75 2.75c0-.6904.5596-1.25 1.25-1.25h10.25V4H4c-.6904 0-1.25-.5596-1.25-1.25Zm13 1.25V1c0-.5523-.4477-1-1-1H4C2.4812 0 1.25 1.2312 1.25 2.75v13.5C1.25 18.3211 2.929 20 5 20h11.75c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2h-1Zm-13 1.2001V16.25c0 1.2426 1.0074 2.25 2.25 2.25h11.25c.5523 0 1-.4477 1-1v-11c0-.5523-.4477-1-1-1H4c-.4501 0-.875-.1081-1.25-.2999ZM11.9393 10.4c-.9773-.9773-2.562-.9773-3.5393 0-.9773.9774-.9773 2.562 0 3.5393.9774.9774 2.562.9774 3.5393 0A.75.75 0 0 1 13 15c-1.5631 1.5631-4.0975 1.5631-5.6606 0-1.5632-1.5631-1.5632-4.0975 0-5.6606 1.5631-1.5632 4.0975-1.5632 5.6606 0A.75.75 0 0 1 11.9393 10.4Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'SidebarDocs'
);
